import texts from "../data/text.json";
import InfoPanel from  "./InfoPanel";

export default function Anamnesis({ lang }) { 
  const section = texts.sections.find((s) => s.id === "anamnesis");
  if (!section) return null;

  return (
    <>
      {section.chapter.map((chap, index) => (
        <InfoPanel key={index} position={[-index * 5, 0.5,0]} title={chap.title[lang]} content={chap.content[lang]} />
      ))}
    </>
  );
}